export default { sha: '7840fe86e8bc1a12d0b7d3410ce403c6925e0f2a', buildNumber: 'undefined' }
